import { FullScreenPageContainer } from '@/components/utils/FullScreenPageContainer';
import { linkoutConfigs } from '@/config/routing/LinkoutConfig';
import * as P from '@/constants/paths';
import { Button } from '@design-system/Button';
import { Link } from 'react-router-dom';

export const RegistrationLanding = () => {
  return (
    <FullScreenPageContainer>
      <h2 className="text-4xl font-sans mb-4 font-medium">
        Let’s get you started
      </h2>
      <div>
        <p className="font-sans text-tertiary">
          Have you registered a kit before?
        </p>
      </div>
      <div className="flex flex-col w-full">
        <Link to={P.REGISTRATION_KIT_ID}>
          <Button
            type="button"
            className="w-full md:max-w-sm py-3 text-white font-semibold bg-black rounded-lg mt-8"
          >
            I’m new to Viome
          </Button>
        </Link>
        <Link to={P.LOGIN_PATH}>
          <Button
            type="button"
            variant="secondary"
            className="w-full md:max-w-sm py-3 font-semibold rounded-lg mt-3"
          >
            Yes, I have a Viome account
          </Button>
        </Link>
      </div>

      <div className="mt-4 text-tertiary">
        <p className="font-sans w-full md:max-w-sm">
          If you are registering a kit for a family member, tap{' '}
          <a
            style={{
              textDecoration: 'underline',
              textDecorationColor: 'black',
              textDecorationThickness: '1.4px',
              textUnderlineOffset: '2px',
            }}
            href={linkoutConfigs.multipleKit}
            onMouseDown={(e) => e.preventDefault()}
          >
            here
          </a>{' '}
          for more information.
        </p>
      </div>
    </FullScreenPageContainer>
  );
};
